import { useMemo } from 'react';

/**
 * Custom hook for programme booking table filters configuration
 * @returns {Array} Filter configuration for AdvancedTable
 */
export const useProgrammeBookingFilters = () => {
    return useMemo(() => [
        {
            id: 'customerName',
            label: 'Customer Name',
            type: 'text',
            placeholder: 'Search by customer name...',
        },
        {
            id: 'programmeName',
            label: 'Programme Name',
            type: 'text',
            placeholder: 'Search by programme name...',
        },
        {
            id: 'status',
            label: 'Status',
            type: 'select',
            options: [
                { value: 'Upcoming', label: 'Upcoming' },
                { value: 'InProgress', label: 'In Progress' },
                { value: 'Completed', label: 'Completed' },
                { value: 'Cancelled', label: 'Cancelled' },
            ],
        },
        {
            id: 'dateRange',
            label: 'Date Range',
            type: 'dateRange',
        },
    ], []);
};
